import {useAppDispatch, useAppSelector} from '../functions/hooks';
import {Error} from '../../components/common/Error';
import {ControlledLoading} from '../../components/common/Loading';
import {useEffect} from 'react';
import {onAppLoad} from '../store/authSlice';
import {useDispatch} from 'react-redux';

const ReduxAuth = ({header, children}) => {
    const dispatch = useDispatch();

    const authenticated = useAppSelector((x) => x.auth.authenticated);
    const hasError = useAppSelector((x) => x.auth.hasError);
    const errorMessage = useAppSelector((x) => x.auth.errorMessage);
    const errorAdditionalDetail = useAppSelector(
        (x) => x.auth.errorAdditionalDetail
    );

    const userLoading = useAppSelector((x) => x.auth.userLoading);
    const user = useAppSelector((x) => x.auth.user);

    useEffect(() => {
        dispatch(onAppLoad());
    }, []);

    if (authenticated && !hasError && !userLoading && user) {
        return (
            <>
                {header}
                {children}
            </>
        );
    } else if (authenticated && !hasError && userLoading) {
        return (
            <>
                {header}
                <ControlledLoading loading={true}></ControlledLoading>
            </>
        );
    } else if (hasError) {
        return (
            <>
                {header}
                <Error
                    errorMessage={errorMessage}
                    errorAdditionalDetail={errorAdditionalDetail}
                />
            </>
        );
    } else {
        return <ControlledLoading loading={true}></ControlledLoading>;
    }
};

export default ReduxAuth;
